export const black = '#000000';
export const white = '#ffffff';
export const ice = '#dfe6f0';
export const chambray = '#2e4487';
export const gallery = '#f0f0f0';
export const mineshaft = '#333333';
export const tango = '#ef7b10';
export const peach = '#fec999';
